export const ACTION_GET_MEDIA_LIBRARY_START = "action_get_MEDIA_LIBRARY_start";
export const ACTION_GET_MEDIA_LIBRARY_FINISH =
  "action_get_MEDIA_LIBRARY_finish";
export const ACTION_GET_MEDIA_LIBRARY_ERROR = "action_get_MEDIA_LIBRARY_error";

export const ACTION_UPLOAD_IMAGE_SUCCESSED = "action_UPLOAD_image_successed";
export const ACTION_UPLOAD_IMAGE_ERROR = "action_UPLOAD_image_error";
